// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-file-list-js": () => import("./../../../src/templates/fileList.js" /* webpackChunkName: "component---src-templates-file-list-js" */),
  "component---src-templates-lang-router-js": () => import("./../../../src/templates/langRouter.js" /* webpackChunkName: "component---src-templates-lang-router-js" */),
  "component---src-templates-router-js": () => import("./../../../src/templates/router.js" /* webpackChunkName: "component---src-templates-router-js" */)
}

